import crossImg from '../../assets/images/cross.svg'
import { fa_currency } from '../../../../utils/PersianNum'
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'
import { Link } from 'react-router-dom';

function Vitrin() {
	const {data : {home: {vitrin : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="product-section" id='vitrin'>
			<div className="container">
				<div className="row">

					<div className="col-md-12 col-lg-3 mb-5 mb-lg-0">
						<h2 className="mb-4 section-title">{name}</h2>
						<p className="mb-4">
							{caption}
						</p>
						{data.btn_button1 && <p><a href={data.btn_button1.key} className="btn">{data.btn_button1.value}</a></p>}
					</div> 

					{data.lso_products && 
						data.lso_products.map((row,index) => 
						<div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0" key={index}>
							<Link className="product-item" to={"/product/" + row.txt_id}>
								<img src={row.img_image} className="img-fluid product-thumbnail" alt="product"/>
								<h3 className="product-title">{row.txt_name}</h3>
								<strong className="product-price">{fa_currency(row.num_price)} تومان</strong>

								<span className="icon-cross"><img src={crossImg} className="img-fluid" alt="cross"/></span>
							</Link>
						</div> 
					)}
				</div>
			</div>
		</div>
    );
}

export default Vitrin;